<!--
 * @Author: 谢树和 shuhe.xie@southgis.com
 * @Date: 2022-09-23 17:18:41
 * @LastEditors: 谢树和 shuhe.xie@southgis.com
 * @LastEditTime: 2022-11-07 10:38:50
 * @FilePath: \standard-v5\src\views\OpinionPublish\OpinionPublishProcess.vue
 * @Description: 意向发布-流程父页面
-->

<template>
  <keep-alive :include="includes">
    <div class="detail">
      <router-view ref="subpage"></router-view>
      <div class="btn-group" v-if="$route.name!='OpinionPublishExplain'">
        <van-button plain type="info" @click="toPrev">上一步</van-button>
        <!-- <van-button type="info" class="btn" v-if="curData.permission.isTemporarySave" @click="saveData">暂存</van-button> -->
        <van-button type="info" class="btn" :disabled="!curData.permission.isTemporarySave" @click="saveData(2)">暂存</van-button>
        <van-button type="info" @click="toNext(true)" v-if="$route.name!='OpinionPublishConfirm'">下一步</van-button>
        <van-button type="info" @click="clickConfirm" v-else>确认发布</van-button>
      </div>
    </div>
  </keep-alive>
</template>

<script>
import api from '@/utils/api/opinionPublish'
import moduleMixins from '@/mixins/moduleMixins'
import { mapMutations } from 'vuex'
export default {
  components: {},
  mixins: [ moduleMixins ],
  name: 'OpinionPublishProcess',
  props: {},
  data() {
    return {
      includes: [],
      process: [
        'OpinionPublishExplain',
        'OpinionPublishProject',
        'OpinionPublishStage',
        'OpinionPublishOrgan',
        'OpinionPublishConfirm'
      ],
      allData: [],
      curData: {
        permission: {}
      },
    }
  },
  watch: {
    // route() {
    //   this.curData = this.allData[this.pageIndex]
    // }
  },
  computed: {
    pageIndex() {
      return this.process.findIndex(name => name==this.$route.name)
    },
    navTitle() {
      return this.curData.componentDesc
    },
  },
  methods: {
    ...mapMutations('opinion', ['setOpinionData', 'setRid']),
    toPrev() {
      // 填写项目信息
      // if(this.pageIndex==1) {}
      // 选择测绘阶段和测绘事项
      // if(this.pageIndex==2) {}
      // 选择测绘机构
      // if(this.pageIndex==3) {}
      // 信息确认
      // if(this.pageIndex==4) {}
      this.curData = this.allData[this.pageIndex-1]
      // this.$router.go(-1)
      this.$router.push({
        name: this.process[this.pageIndex-1]
      })
    },
    // check:true检测必填
    toNext(check) {
      console.log(this.$refs['subpage'])
      let page = this.$refs['subpage']
      // 填写项目信息
      if(this.pageIndex==1) {
        if(check && !page.isCheck) {
          this.$toast('请填写全部必填项')
          return false
        } else {
          // 能把填写数据注入allData
          console.log(page.componentData)
          let cData = page.componentData
          for(let key in cData) {
            this.allData[1].data[key] = cData[key]
          }
        }
      }
      // 选择测绘阶段和测绘事项
      if(this.pageIndex==2) {
        let rData = page.renderData
        let arr = []
        rData.forEach(el => {
          el.children.forEach(item => {
            if(item.checked) arr.push({
              CLSXCode: item.key,
              CLSXName: item.value,
              CHZYDWRID: "",
              chdwmc: "",
              chdwshxydm: "",
              cldw: "",
              bigClass: el.title,
              isChecked: true,
              measuringType: "多测合一"
            })
          })
        })
        if(check && arr.length==0) {
          this.$toast('至少选择一个测绘事项')
          return
        }
        this.allData[2].data.CLSX = arr
      }
      // 选择测绘机构
      if(this.pageIndex==3) {
        let cData = page.componentData
        if(check && cData.data.length==0) {
          this.$toast('至少选择一个测绘机构')
          return
        }
        cData.searchParams = page.params
        this.allData[3] = cData
      }
      
      if(check) {
        this.curData = this.allData[this.pageIndex+1]
        this.setOpinionData(this.allData)
        this.$router.push({
          name: this.process[this.pageIndex+1]
        })
      }
    },
    saveData(type) {
      this.toNext(false)

      // 获取用户信息及rid注入
      // console.log(this.$store.state.userInfo)
      let rid = this.$store.state.opinion.rid
      if(rid) {
        this.allData[6].docunid = rid
        this.allData[6].RID = rid
      }
      api.submitIntention({
        type, // 1:提交意向发布 2:暂存意向发布
        data: this.allData
      }).then(res => {
        if(res.code==0) {
          let rid = res.data
          console.log(rid)
          if(type==1) {
            this.$refs['subpage'].showSuccess = true
          } else {
            // this.$toast.success('保存成功')
            this.$dialog.alert({
              title: '—— 提示 ——',
              message: '保存成功',
            })
          }
          if(!this.allData[6].docunid) {
            this.allData[6].docunid = rid
            this.allData[6].RID = rid
          }
          this.setRid(rid)
        } else {
          // this.$toast(res.message)
        }
      })
    },
    clickConfirm() {
      this.$dialog
        .confirm({
          title: '—— 提示 ——',
          message: '确认提交当前意向吗？',
          confirmButtonColor: '#1D84FF'
        })
        .then(() => {
          this.saveData(1)
        })
    },
    getConfig() {
      api.getIntentionConfig().then(res => {
        this.allData = res.data
        this.setOpinionData(res.data)
        if(this.pageIndex==0) {
          this.curData = this.allData[0]
          this.$refs['subpage'].data = res.data[0].data
          this.$refs['subpage'].componentDesc = res.data[0].componentDesc

          // 获取用户信息注入
          // console.log(this.$store.state.userInfo)
          let userInfo = this.$store.state.userInfo
          this.allData.push({
            userID: userInfo.RID,
            docunid: "",
            RID: ""
          })
        }

        // 继续发布接口，获取暂存数据
        // api.continueIntention({
        //   rid: this.data.RID
        // }).then(res => {
        //   let storageData = JSON.parse(res.data)
        //   this.allData.forEach((item, i) => {
        //     if(i <= storageData[7].current) item.data = storageData[i]
        //   })
        //   this.setOpinionData(this.allData)
        //   // console.log(allData)
        //   this.setRid(this.data.RID)
        // })
      })
    }
  },
  created() {
    let oData = this.$store.state.opinion.opinionData
    if(JSON.stringify(oData)=='{}') {
      this.getConfig()
    } else {
      this.allData = oData
    }
    // console.log(this.$route, this.pageIndex)
  },
  mounted() {
    //提交成功退回到首页
    this.$bus.$off('onBack')
    this.$bus.$on('onBack', () => {
      if (window.__wxjs_environment === 'miniprogram') {
        wx.miniProgram.navigateBack({
          delta: 1
        })
      } else {
        this.$router.go(-5)
      }
    })
  }
}
</script>
<style lang="scss" scoped>
.detail {
  .btn-group {
    width: 100%;
    padding: 10px 0;
    text-align: center;
    background-color: #fff;
    position: fixed;
    bottom: 0;
    display: flex;
    justify-content: space-around;
    // box-shadow: 0px -5px 5px -5px #ccc;
    border-top: 1px solid #eee;
    .btn {
      padding: 14px 20px;
      font-weight: 500;
      color: #ffffff;
      border: 1px solid transparent;
    }
  }
}
</style>
